import { Theme } from "../component/navigation/ThemeDropdown";

export default function ReferencesIcon({
    isSelected,
    theme,
}: {
    isSelected: boolean;
    theme: Theme;
}) {
    return (
        <div style={{ display: "inline-block", cursor: "pointer" }}>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                <path
                    d="M18.6534 6.48547H5.3496C5.10508 6.48547 4.90686 6.6837 4.90686 6.92822V17.0717C4.90686 17.3163 5.10508 17.5145 5.3496 17.5145H18.6534C18.8979 17.5145 19.0962 17.3163 19.0962 17.0717V6.92822C19.0962 6.6837 18.8979 6.48547 18.6534 6.48547Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#FFFFFF"
                                : "#606161"
                            : isSelected
                              ? "#2D3748"
                              : "#2D3748"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                <path
                    d="M13.9542 6.03054V13.4137C13.9542 13.4504 14 13.4718 14.0275 13.4443L15.7252 11.9084C15.7405 11.8931 15.768 11.8931 15.7832 11.9084L17.4809 13.4443C17.5084 13.4687 17.5542 13.4504 17.5542 13.4137V6.03054C17.5542 6.00611 17.5359 5.98779 17.5115 5.98779H14C13.9756 5.98779 13.9573 6.00611 13.9573 6.03054H13.9542Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
            </svg>
        </div>
    );
}
